.subcategory-promo-blocks {
  height: 300px;
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  color: #ffffff;
  position: relative;
  margin-bottom: 20px;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks {
    height: 255px;
  }
}

.subcategory-promo-blocks__image-wrap {
  height: 130px;
  position: relative;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__image-wrap {
    height: 255px;
  }
}

.subcategory-promo-blocks__image-wrap ::after {
  position: absolute;
  content: "";
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

:host(:not([dir="rtl"])) .subcategory-promo-blocks__image-wrap ::after {
  background: linear-gradient(90deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.1) 63%, transparent);
}

:host([dir="rtl"]) .subcategory-promo-blocks__image-wrap ::after {
  background: linear-gradient(-90deg, rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.1) 63%, transparent);
}

.subcategory-promo-blocks__wrapper {
  position: relative;
  margin: 0;
  padding: 0;
  border: 0;
  font: inherit;
  vertical-align: baseline;
  border: 1px solid #e7e6e6;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__wrapper {
    border: none;
  }
}

.subcategory-promo-blocks__picture {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 130px;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__picture {
    height: 100%;
  }
}

.subcategory-promo-blocks__picture source {
  width: 100%;
  height: 100%;
}

.subcategory-promo-blocks__picture img {
  min-width: 100%;
  min-height: 100%;
  max-width: 100%;
  max-height: 100%;
  object-fit: cover;
  position: absolute;
}

:host(:not([dir="rtl"])) .subcategory-promo-blocks__picture img {
  right: 0;
}

:host([dir="rtl"]) .subcategory-promo-blocks__picture img {
  left: 0;
}

.subcategory-promo-blocks__context {
  position: relative;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 20px !important;
  color: #333333;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__context {
    position: absolute;
    color: #ffffff;
  }

  :host(:not([dir="rtl"])) .subcategory-promo-blocks__context {
    padding: 40px 70px 30px 52px;
  }

  :host([dir="rtl"]) .subcategory-promo-blocks__context {
    padding: 40px 52px 30px 70px;
  }
}

.subcategory-promo-blocks__context-description {
  margin: 0;
  margin-bottom: 10px;
  font-size: 0.875rem;
  line-height: 1.25rem;
  width: auto;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__context-description {
    font-size: 1rem;
    line-height: 1.5625rem;
    width: 600px;
  }
}

.subcategory-promo-blocks__context h3 {
  font-size: 1.125rem;
  line-height: 1.5625rem;
  padding-bottom: 10px;
  max-width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  margin-top: 0;
  margin-bottom: 0;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__context h3 {
    font-size: 1.875rem;
    padding-bottom: 20px;
    line-height: 2.5rem;
  }
}

.subcategory-promo-blocks__context-link {
  font-size: 0.875rem;
  font-weight: normal;
  line-height: 1.5625rem;
  color: #42b4e6;
  text-decoration: none;
}

.subcategory-promo-blocks__context-link:visited, .subcategory-promo-blocks__context-link:active {
  text-decoration: none;
}

.subcategory-promo-blocks__context-link:hover {
  text-decoration: underline;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__context-link {
    font-size: 1rem;
    font-weight: 700;
    color: #ffffff;
  }
}

.subcategory-promo-blocks__context-link-icon {
  position: relative;
  color: #42b4e6;
}

:host(:not([dir="rtl"])) .subcategory-promo-blocks__context-link-icon {
  left: 2px;
}

:host([dir="rtl"]) .subcategory-promo-blocks__context-link-icon {
  right: 2px;
    transform: scaleX(-1);
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__context-link-icon {
    color: #ffffff;
  }
}

.subcategory-promo-blocks__logo-block {
  position: absolute;
}

@media screen and (max-width: 979px) {
  .subcategory-promo-blocks__logo-block {
    top: -25px;
  }

  :host(:not([dir="rtl"])) .subcategory-promo-blocks__logo-block {
    right: 5px;
  }

  :host([dir="rtl"]) .subcategory-promo-blocks__logo-block {
    left: 5px;
  }
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__logo-block {
    bottom: 5px;
  }

  :host(:not([dir="rtl"])) .subcategory-promo-blocks__logo-block {
    right: 20px;
  }

  :host([dir="rtl"]) .subcategory-promo-blocks__logo-block {
    left: 20px;
  }
}

.subcategory-promo-blocks__logo-block img {
  max-height: 10px;
  width: auto;
  max-width: 100px;
}

@media screen and (min-width: 980px) {
  .subcategory-promo-blocks__logo-block img {
    max-height: 20px;
    width: auto;
    max-width: 150px;
  }
}